/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {flowComplete} from '../api'

export const useMutationFlowComplete = createReactQueryMutationHook('flowComplete', flowComplete)
